/* eslint-disable complexity */
/* eslint-disable no-unused-vars */
/* eslint-disable max-params */
/* eslint-disable space-infix-ops */
/* eslint-disable max-statements */
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import useLoginGate from "./use-login-gate";
import { AU_MOBILE_EVENTS } from "../tracking/au.mobile-events";
import { yieldToMain } from "../utils/helpers/yield-to-main";
import { getCheckoutPageURL, getSimilarCarDetailsPageURL } from "../utils/helpers/get-detail-page-url";
import { CHECKOUT_ROUTE_PATHS, TASKS_ROUTE_PATHS } from "../constants/au.desktop/checkout-route-paths";
import { CHECKOUT_STEPS, CHECKOUT_STEPS_PATH, FINANCE_TYPE, LOGIN_TYPE, ORDER_STATUS, VERIFY_LICENCE_STATES } from "../constants/checkout-constants";
import { desktopCleverTapEvent, mobileCleverTapEvent, trackCustomReMarketingEvents, trackDesktopCustomEventsAU, trackMobileCustomEventsAU } from "../tracking";
import { FB_EVENTS_CATEGORY } from "../tracking/fb-events";
import { MARKETING_EVENTS_CONSTANTS } from "../tracking/marketing-page-events";
import carListingEventDataParserGA4 from "../tracking/parser/car-listing-ga4";
import { CAR_LIST_EVENT_NAMES, LEAD_APPOINTMENT_STATUS, LEAD_GENERATION_FORM_CONFIG_KEYS, LOAN_PROVIDER, LOGIN_SOURCE, ORDER_TYPE } from "../constants/app-constants";
import useEwPayload from "./use-ew-payload";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";
import clevertapDetails from "../tracking/parser/clevertap-details";
import { CLEVERTAP_EVENT_MAP } from "../tracking/au.mobile-clevertap";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_MOBILE } from "../components/au.mobile/video-gallery/tracking";
import isTestDriveEnabledState from "../utils/helpers/is-test-drive-enabled-state";
import { AU_DESKTOP_EVENTS } from "../tracking/au.desktop-events";
import getCarInfo from "../utils/helpers/get-car-info";
import { getDealerPage } from "../utils/helpers/get-dealer-route";
import { GA_EVENTS as CLASSIFIED_GA_EVENTS } from "../components/au.mobile/login/tracking";
import { getCarPrice } from "../utils/helpers/calculate-egc-dap";

export default function useCarDetailsCta({
    carId,
    content,
    config,
    isWishlistedCar,
    onClickAddToWishList,
    isLoggedIn,
    secureToken,
    comingSoon,
    make,
    model,
    appointmentId,
    orderId,
    orderStatus,
    isExtendedWarrantySelected,
    isFinanceFirstCheckout,
    updateOrderConnect,
    updateValidC2bOrderConnect,
    setCheckoutLoginTypeConnect,
    openLoginPopupConnect,
    setOnLoginSuccessCallback,
    egc,
    isUserZeroDpVariant,
    extendedWarrantyOpted,
    showTradeInCheckoutStep,
    eligibleForExtendedWarranty,
    postOrderBookingConfirmed,
    getMyBookingCarDetailsURL,
    booked,
    listingActive,
    reserved,
    similarCars,
    fetchSimilarCarsConnect,
    testDriveStatus,
    showTestDriveLocationVariant,
    getOrderDetailConnect,
    getCheckoutStepsConnect,
    carDetails,
    fireEwSkippedCTEvent,
    isVideoGallery = false,
    eligibleStateNames,
    userGeoData,
    financeProvider,
    drivingLicenceStatus,
    calledFrom = "msite",
    phoneNumberVerified,
    isCdpCtaReorderVariant,
    leadAppointment,
    createClassifiedLeadConnect,
    dealerInfo,
    createOrderConnect,
    order,
    orderCustomerPhoneNumber,
    handleShowLoggedInDealerRedirect
}) {
    const history = useHistory();
    const [ctaLoading, setCtaLoading] = useState(false);
    const [carReservationModalOpen, setCarReservationModal] = useState(false);
    const [notifyIconCliked, setNotifyIconClicked] = useState(false);
    const [wishlistActionCompleted, setWishlistActionCompleted] = useState(false);
    const { ewRequestPayload, ewRequestBody } = useEwPayload();
    const [commingSoonModal, setCommingSoonModal] = useState(false);
    const [isResumeVisible, setIsResumeVisible] = useState(false);
    const [isFetchingOrderDetails, setIsFetchingOrderDetails] = useState(false);
    const [step, setStep] = useState(null);
    const pendingActionRef = useRef(null);
    const loginGate = useLoginGate({
        requiredFields: ["profileName", "email", "mobile"],
        closableModal: true,
        onComplete: () => {
            const action = pendingActionRef.current;
            pendingActionRef.current = null;
            if (action) action();
        }
    });
    const { state: { name: userState = {} } = {} } = userGeoData || {};
    const {city, state} = content || {};
    const {isDealerListing} = getCarInfo(content) || {};
    const enableNewPostBook = (financeProvider === LOAN_PROVIDER.NONE || financeProvider === LOAN_PROVIDER.BYOF) && (drivingLicenceStatus === VERIFY_LICENCE_STATES.UPLOAD_PENDING);
    const phoneNumberInOrder = orderCustomerPhoneNumber || order?.deliveryAddress?.customerPhoneNumber;
    const hasOrderForComingSoonCar = comingSoon && Boolean(orderId) && Boolean(phoneNumberInOrder);

    const getOrder = useCallback(async () => {
        try {
            setIsFetchingOrderDetails(true);
            const response = await getOrderDetailConnect(carId);
            const stepResponse = await getCheckoutStepsConnect(response.orderId);
            setStep(stepResponse);
            if (stepResponse.step && stepResponse.nextStep) {
                setIsResumeVisible(true);
            }
        } catch (err) {
            // createOrderConnect()
        } finally {
            setIsFetchingOrderDetails(false);
        }
        // eslint-disable-next-line
    }, [carId, appointmentId]);

    // --- Wishlist Logic ---
    const wishlistSuccessCallback = (shortListed, showNotifyPopup) => {
        if (shortListed && showNotifyPopup) {
            setNotifyIconClicked(false);
            setWishlistActionCompleted(true);
            setCarReservationModal(true);
        }
    };

    const ecommerEventData = () => {
        const data = carListingEventDataParserGA4(content, {
            list: CAR_LIST_EVENT_NAMES.DETAILS
        });
        return data;
    };

    const addItemToWishlist = (token, additionalProps = {}, gtmFrom) => {
        const { addtoWishList } = ecommerEventData();
        trackMobileCustomEventsAU(FB_EVENTS_CATEGORY.CDP_ADD_TO_WISHLIST, { content: addtoWishList });
        onClickAddToWishList(
            carId,
            token || secureToken,
            gtmFrom || "car_detail_page",
            { ...additionalProps, comingSoon, make, model, callback: wishlistSuccessCallback },
            { detailsContent: content, detailsConfig: config }
        );
    };

    const onWishlistClick = async (e, gtmFrom, showNotifyPopup, source=null) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        await yieldToMain();
        if (isLoggedIn) {
            addItemToWishlist("", { showNotifyPopup }, gtmFrom);
        } else {
            openLoginPopupConnect();
            await yieldToMain();
            if (setCheckoutLoginTypeConnect) setCheckoutLoginTypeConnect(LOGIN_TYPE.WISHLIST);
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.LOGIN_INITIATED, { eventLabel: "wishlist" });
            if (source === "video_gallery") {
                trackMobileCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CAR_WISHLIST, {});
            }
            setOnLoginSuccessCallback((resp) => {
                const { access_token: token } = resp.profileResponse || resp;
                addItemToWishlist(token, { showNotifyPopup }, gtmFrom);
            });
        }
    };

    // --- Notify Icon Logic ---
    const onClickNotifyIcon = () => {
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.RESERVATION_NOTIFY_ME_TOOLTIP);
        setNotifyIconClicked(true);
        setCarReservationModal(true);
    };

    const updateOrderForBuyNow = async () => {
        const eventLabel = isExtendedWarrantySelected ? "yes" : "no";
        const redirectionUrl = isFinanceFirstCheckout ? CHECKOUT_ROUTE_PATHS.ffOverview : CHECKOUT_ROUTE_PATHS.deliveryDetails;
        const deeplinkUrl = window.location.href;
        if (orderId && ORDER_STATUS.EXPIRED !== orderStatus) {
            const variantPayload = {
                "userVariants": [
                    {
                        "name": "finance-first-checkout-revamp",
                        "value": isFinanceFirstCheckout ? EXPERIMENT_TYPE.VARIANT_B : EXPERIMENT_TYPE.VARIANT_A
                    }
                ],
                ...ewRequestBody
            };

            updateOrderConnect(orderId, ewRequestPayload, variantPayload).then(() => {
                const { relativeURL } = getCheckoutPageURL(content, redirectionUrl);
                history.push(relativeURL);
            });
            await yieldToMain();
            if (setCheckoutLoginTypeConnect) setCheckoutLoginTypeConnect("NORMAL");

        } else {
            const { relativeURL } = getCheckoutPageURL(content, redirectionUrl);
            history.push(relativeURL);
        }
        updateValidC2bOrderConnect(secureToken);
        await yieldToMain();
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CARS24_DETAIL_PAGE, {
            eventAction: "cta_selected",
            eventLabel: "buy_online"
        });
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CARS24_DETAIL_PAGE, {
            eventAction: "extended_warranty",
            eventLabel
        });
        if (fireEwSkippedCTEvent) fireEwSkippedCTEvent(deeplinkUrl);
        if (isVideoGallery) {
            trackMobileCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CHECKOUT_INITIATED, {
                ...VIDEO_CATALOG_GA_EVENTS_MOBILE.VIDEO_CHECKOUT_INITIATED,
                eventLabel: "No"
            });
        }
    };

    const onGetStartedLoginSuccess = async (event, ctaSource) => {
        if (event === AU_MOBILE_EVENTS.CAR_DETAILS_ATF_INTERACTIONS) {
            trackMobileCustomEventsAU(event, { eventLabel: "selected get_started" });
        } else if (event === AU_MOBILE_EVENTS.CAR_DETAILS_PRICE_BREAK_DOWN_GET_STARTED) {
            trackMobileCustomEventsAU(event);
        } else if (event === AU_MOBILE_EVENTS.CAR_DETAILS_COMPARE_GET_STARTED) {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_COMPARE_GET_STARTED, {
                eventLabel: ctaSource
            });
        }
    };
    const proceedWithClassifiedLead = (dealerRoute) => {
        trackMobileCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED, {
            ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_INITIATED,
            eventLabel: "Checkout"
        });
        createClassifiedLeadConnect().then((leadResponse) => {
            trackMobileCustomEventsAU(CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED, {
                ...CLASSIFIED_GA_EVENTS.CLASSIFIED_LEAD_COMPLETED,
                eventLabel: leadResponse?.leadCode || null
            });
        });
        if (handleShowLoggedInDealerRedirect) {
            handleShowLoggedInDealerRedirect(dealerRoute);
        } else {
            history.push(dealerRoute);
        }
    };

    const handleClassified = () => {
        const { dealerCode } = getCarInfo(content) || {};
        const dealerName = dealerInfo?.[dealerCode]?.name || "";
        const dealerRoute = getDealerPage(dealerName, dealerCode);

        // Already confirmed lead - just redirect
        if (isLoggedIn && carDetails?.leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            history.push(dealerRoute);
            return;
        }

        pendingActionRef.current = () => proceedWithClassifiedLead(dealerRoute);
        loginGate.trigger();
    };

    const handleComingSoonEnquire = async () => {
        let existingOrderId = orderId;

        if (isLoggedIn && !existingOrderId && createOrderConnect) {
            try {
                const orderPayload = {
                    appointmentId: appointmentId || content?.appointmentId || carId,
                    vehiclePrice: getCarPrice({
                        egcPrice: content?.egc,
                        dapPrice: content?.price
                    }).egc.value,
                    orderType: ORDER_TYPE.BUY_ONLINE
                };
                const orderResponse = await createOrderConnect(orderPayload);
                existingOrderId = orderResponse?.orderId || existingOrderId;
            } catch (err) {
                // no-op: fallback to existing login popup flow
            }
        }

        openLoginPopupConnect({
            additionalInfo: {
                loginSource: LOGIN_SOURCE.COMING_SOON,
                source: "Checkout",
                appointmentId,
                orderId: existingOrderId,
                carDetails: content,
                leadGenerationConfigKey: LEAD_GENERATION_FORM_CONFIG_KEYS.COMING_SOON
            }
        });
    };

    const onGetStartedClick = async (event) => {
        setCtaLoading(true);
        await yieldToMain();
        pendingActionRef.current = async () => {
            await updateOrderForBuyNow();
            await yieldToMain();
            if (event === AU_MOBILE_EVENTS.CAR_DETAILS_PRICE_BREAK_DOWN_GET_STARTED) {
                trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_PRICE_BREAK_DOWN_GET_STARTED);
            } else if (event === AU_MOBILE_EVENTS.CAR_GALLERY_VIEW) {
                trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_GALLERY_VIEW, {
                    eventLabel: "selected get_started"
                });
            }
        };
        loginGate.trigger();
        if (!isLoggedIn) {
            trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CARS24_DETAIL_PAGE, { eventAction: "sign_up", eventLabel: "sign_up_screen_shown" });
        }
        setCtaLoading(false);
        await yieldToMain();
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, {
            eventLabel: "selected get_started"
        });
        trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.BOOKING_INITIATED, {
            ecomm_prodid: appointmentId,
            ecomm_totalvalue: egc
        });
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.ZERO_DP_CDP, {
            eventLabel: isUserZeroDpVariant ? "Clicked_Variant B" : "Clicked_Variant A"
        });
    };

    const onResumeRedirect = async () => {
        setCtaLoading(true);
        const deeplinkUrl = window.location.href;
        if (isLoggedIn) {
            updateValidC2bOrderConnect(secureToken);

            const params = {
                orderType: ORDER_TYPE.BUY_ONLINE,
                ...ewRequestPayload
            };
            let variantPayload = {};

            if (isFinanceFirstCheckout) {
                variantPayload = {
                    "userVariants": [
                        {
                            "name": "finance-first-checkout-revamp",
                            "value": isFinanceFirstCheckout ? EXPERIMENT_TYPE.VARIANT_B : EXPERIMENT_TYPE.VARIANT_A
                        }
                    ],
                    ...ewRequestBody
                };
            }

            await updateOrderConnect(orderId, params, variantPayload);
            let routeStep = "";
            if (step.nextStep === CHECKOUT_STEPS.TRADEIN && !showTradeInCheckoutStep) {
                routeStep = (!eligibleForExtendedWarranty) ? CHECKOUT_STEPS.ADDONS : CHECKOUT_STEPS.CARCOVER;
            } else {
                routeStep = step.nextStep;
            }
            let { relativeURL } = getCheckoutPageURL({ make, model, appointmentId }, CHECKOUT_ROUTE_PATHS[CHECKOUT_STEPS_PATH[routeStep]]);
            if (isFinanceFirstCheckout) {

                relativeURL = getCheckoutPageURL({ make, model, appointmentId }, CHECKOUT_ROUTE_PATHS.ffOverview)?.relativeURL;
            }
            history.push(relativeURL);
            if (setCheckoutLoginTypeConnect) setCheckoutLoginTypeConnect("NORMAL");
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => {
                let { relativeURL } = getCheckoutPageURL({ make, model, appointmentId }, CHECKOUT_ROUTE_PATHS[CHECKOUT_STEPS_PATH[step.nextStep]]);
                if (isFinanceFirstCheckout) {
                    relativeURL = getCheckoutPageURL({ make, model, appointmentId }, CHECKOUT_ROUTE_PATHS.ffOverview)?.relativeURL;
                }
                history.push(relativeURL);
            });
        }
        setCtaLoading(false);
        if (fireEwSkippedCTEvent) fireEwSkippedCTEvent(deeplinkUrl);
    };

    const handleCarReservationModal = () => {
        const curVal = carReservationModalOpen;
        setCarReservationModal((prev) => !prev);
        if (!curVal) {
            setWishlistActionCompleted(false);
            setNotifyIconClicked(false);
        }
    };

    const handleSimilarCar = () => {

        if ((similarCars || []).length === 0) {
            fetchSimilarCarsConnect(carId, { size: 20, userFinanceType: FINANCE_TYPE.CARS24 });
        }
        const { relativeURL } = getSimilarCarDetailsPageURL(content, "default");

        history.push(relativeURL);
    };

    const handleCommingSoonModal = () => {
        setCommingSoonModal(!commingSoonModal);
        // setLoading(false);
    };

    const getNotify = () => {
        // setLoading(true);
        const carStatus = { comingSoon, make, model };
        if (isLoggedIn) {
            addItemToWishlist(null, { callback: handleCommingSoonModal, carStatus });
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback((resp) => {
                const { access_token: token } = resp;
                addItemToWishlist(token, { callback: handleCommingSoonModal, comingSoon: true });
            });
        }
        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.COMING_SOON_NOTIFY_ME);

    };

    const getDealershipCta = () => {
        if (isLoggedIn && carDetails?.leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            return "View dealer";
        }
        return "Contact dealer";
    };

    const getCtaForDesktop = () => {
        let text = "Get started";
        let action = onGetStartedClick;
        let disabled = false;
        let iconType = "Wishlist";
        let transparentButton = false;
        let key = "";
        let similarCarAction;
        let similarCarText;
        let type;
        if (isResumeVisible && isLoggedIn) {
            text = "Continue buying";
            action = onResumeRedirect;
            disabled = false;
        }
        if (isTestDriveEnabledState({ state, userState, eligibleStateNames })) {
            text = "Get started";
        }
        if (postOrderBookingConfirmed(orderStatus)) {
            text = "Track order";
            disabled = false;
            action = (data, e, ctaSource = null) => {
                const { relativeURL: viewTaskUrl } = getMyBookingCarDetailsURL(
                    content.appointmentId,
                    enableNewPostBook ? TASKS_ROUTE_PATHS.driverLicence : TASKS_ROUTE_PATHS.viewTask,
                    null,
                    null
                );
                if (ctaSource) {
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_TRACK_ORDER, {
                        eventLabel: ctaSource
                    });
                }
                history.push(viewTaskUrl);
            };
        } else if (booked || !listingActive) {
            text = "Sold";
            disabled = true;
            action = () => { };
        } else if (reserved) {
            if (orderStatus === ORDER_STATUS.TEST_DRIVE_RESERVED) {
                text = "Get started";
                disabled = false;
                iconType = null;
                action = updateOrderForBuyNow;
            } else if (isWishlistedCar(carId)) {
                text = "Remove from wishlist";
                disabled = false;
                iconType = null;
                key = "removedReservationNofication";
                type = "notify";
                action = (data, e, ctaSource = null) => {
                    const deeplinkUrl = window.location.href;
                    handleCarReservationModal();
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_REMOVE_FROM_WISHLIST, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST, {
                            eventLabel: "reserved"
                        });
                    }
                    if (fireEwSkippedCTEvent) fireEwSkippedCTEvent(deeplinkUrl);
                };
                similarCarText = "View similar";
                similarCarAction = handleSimilarCar;
                transparentButton = true;
            } else {
                text = "Notify if available";
                disabled = false;
                iconType = "Info";
                key = "addReservationNotification";
                action = (data, e, ctaSource = null) => {
                    const showNotifyPopup = true;
                    onWishlistClick(e, "", showNotifyPopup);
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_NOTIFY_IF_AVAILABLE, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_CTA);
                    }
                    const detailsData = clevertapDetails(content, { prefix: "notify_", config });
                    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.NOTIFY_ME, detailsData);
                    // handleCarReservationModal();
                };
            }
        } else if (comingSoon) {
            text = "Enquire now";
            disabled = hasOrderForComingSoonCar;
            iconType = null;
            action = handleComingSoonEnquire;
            key = "comingSoon";
        }
        if (testDriveStatus === ORDER_STATUS.TEST_DRIVE_COMPLETED) {
            text = "Continue buying";
        }
        if (isDealerListing && listingActive && !comingSoon) {
            text = getDealershipCta();
            disabled = false;
            action = handleClassified;
            iconType = null;
            transparentButton=false;
        }
        return { text, action, disabled, iconType, transparentButton, key, similarCarAction, similarCarText, type };
    };

    const getCta = () => {
        let text = "Get started";
        let action = onGetStartedClick;
        let disabled = false;
        let iconType = "Wishlist";
        let transparentButton = false;
        let key = "";
        let similarCarAction;
        let similarCarText;
        let type;
        const wishlistedCar = isWishlistedCar(appointmentId);
        if (isResumeVisible && isLoggedIn) {
            text = "Continue buying";
            action = onResumeRedirect;
            disabled = false;
        }
        if (postOrderBookingConfirmed(orderStatus)) {
            text = "Track order";
            disabled = false;
            action = (data, e, ctaSource = null) => {
                if (ctaSource) {
                    trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_COMPARE_TRACK_ORDER, {
                        eventLabel: ctaSource
                    });
                }
                const { relativeURL: viewTaskUrl } = getMyBookingCarDetailsURL(
                    content.appointmentId,
                    TASKS_ROUTE_PATHS.addOns,
                    null,
                    null
                );
                history.push(viewTaskUrl);
            };
        } else if (booked || !listingActive) {
            text = "Sold";
            disabled = true;
            action = () => {};
        } else if (reserved) {
            if (orderStatus === ORDER_STATUS.TEST_DRIVE_RESERVED) {
                text = "Get started";
                disabled = false;
                iconType = null;
                action = updateOrderForBuyNow;
                transparentButton = false;
            } else if (wishlistedCar) {
                text = "Remove from wishlist";
                disabled = false;
                iconType = null;
                key = "removedReservationNofication";
                type = "notify";
                action = (data, e, ctaSource = null) => {
                    handleCarReservationModal();
                    if (ctaSource) {
                        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_COMPARE_REMOVE_FROM_WISHLIST, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST, {
                            eventLabel: "reserved"
                        });
                    }

                };
                similarCarText = "View similar";
                similarCarAction = handleSimilarCar;
                transparentButton = true;
            } else {
                text = "Notify if available";
                disabled = false;
                iconType = "Info";
                key = "addReservationNotification";
                action = (data, e, ctaSource = null) => {
                    const showNotifyPopup = true;
                    onWishlistClick(e, "", showNotifyPopup);
                    if (ctaSource) {
                        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CAR_DETAILS_COMPARE_NOTIFY_IF_AVAILABLE, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackMobileCustomEventsAU(AU_MOBILE_EVENTS.RESERVATION_NOTIFY_ME_CTA);
                    }

                    // handleCarReservationModal();
                };
            }
        } else if (comingSoon) {
            text = "Enquire now";
            disabled = hasOrderForComingSoonCar;
            iconType = null;
            action = handleComingSoonEnquire;
            key = "comingSoon";
        }
        if (testDriveStatus === ORDER_STATUS.TEST_DRIVE_COMPLETED && showTestDriveLocationVariant && !(booked || !listingActive || reserved)) {
            text = "Continue buying";
        }
        if (isDealerListing && listingActive && !comingSoon) {
            text = getDealershipCta();
            disabled = false;
            action = handleClassified;
            transparentButton = false;
            iconType = null;
        }
        return { text, action, disabled, iconType, transparentButton, key, isWishlistedCar: wishlistedCar, similarCarAction, similarCarText, type};
    };

    const cta = calledFrom === "msite" ? getCta() : getCtaForDesktop();

    return {
        isWishlisted: isWishlistedCar(carId),
        onWishlistClick,
        onClickNotifyIcon,
        isFetchingOrderDetails: ctaLoading,
        cta,
        carReservationModalOpen,
        notifyIconCliked,
        wishlistActionCompleted,
        setCarReservationModal,
        setNotifyIconClicked,
        setWishlistActionCompleted,
        setIsResumeVisible,
        handleCarReservationModal,
        handleCommingSoonModal,
        handleSimilarCar,
        // export all the functions
        addItemToWishlist,
        updateOrderForBuyNow,
        onGetStartedClick,
        onResumeRedirect,
        getNotify,
        getCta,
        isResumeVisible,
        step,
        state,
        userState,
        eligibleStateNames,
        enableNewPostBook
    };
}
